export const prependAsterisks = (value: string) => {
  return '**********' + value;
};
